/**
 * @file text-track-list.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _trackList = require('./track-list');

var _trackList2 = _interopRequireDefault(_trackList);

var _utilsFnJs = require('../utils/fn.js');

var Fn = _interopRequireWildcard(_utilsFnJs);

var _utilsBrowserJs = require('../utils/browser.js');

var browser = _interopRequireWildcard(_utilsBrowserJs);

var _globalDocument = require('global/document');

var _globalDocument2 = _interopRequireDefault(_globalDocument);

/**
 * A list of possible text tracks. All functionality is in the
 * base class TrackList. The spec for TextTrackList is located at:
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist
 *
 * interface TextTrackList : EventTarget {
 *   readonly attribute unsigned long length;
 *   getter TextTrack (unsigned long index);
 *   TextTrack? getTrackById(DOMString id);
 *
 *   attribute EventHandler onchange;
 *   attribute EventHandler onaddtrack;
 *   attribute EventHandler onremovetrack;
 * };
 *
 * @param {TextTrack[]} tracks A list of tracks to initialize the list with
 * @extends TrackList
 * @class TextTrackList
 */

var TextTrackList = (function (_TrackList) {
  _inherits(TextTrackList, _TrackList);

  function TextTrackList() {
    var tracks = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

    _classCallCheck(this, TextTrackList);

    var list = undefined;

    // IE8 forces us to implement inheritance ourselves
    // as it does not support Object.defineProperty properly
    if (browser.IS_IE8) {
      list = _globalDocument2['default'].createElement('custom');
      for (var prop in _trackList2['default'].prototype) {
        if (prop !== 'constructor') {
          list[prop] = _trackList2['default'].prototype[prop];
        }
      }
      for (var prop in TextTrackList.prototype) {
        if (prop !== 'constructor') {
          list[prop] = TextTrackList.prototype[prop];
        }
      }
    }

    list = _TrackList.call(this, tracks, list);
    return list;
  }

  TextTrackList.prototype.addTrack_ = function addTrack_(track) {
    _TrackList.prototype.addTrack_.call(this, track);
    track.addEventListener('modechange', Fn.bind(this, function () {
      this.trigger('change');
    }));
  };

  /**
   * Remove TextTrack from TextTrackList
   * NOTE: Be mindful of what is passed in as it may be a HTMLTrackElement
   *
   * @param {TextTrack} rtrack
   * @method removeTrack_
   * @private
   */

  TextTrackList.prototype.removeTrack_ = function removeTrack_(rtrack) {
    var track = undefined;

    for (var i = 0, l = this.length; i < l; i++) {
      if (this[i] === rtrack) {
        track = this[i];
        if (track.off) {
          track.off();
        }

        this.tracks_.splice(i, 1);

        break;
      }
    }

    if (!track) {
      return;
    }

    this.trigger({
      track: track,
      type: 'removetrack'
    });
  };

  /**
   * Get a TextTrack from TextTrackList by a tracks id
   *
   * @param {String} id - the id of the track to get
   * @method getTrackById
   * @return {TextTrack}
   * @private
   */

  TextTrackList.prototype.getTrackById = function getTrackById(id) {
    var result = null;

    for (var i = 0, l = this.length; i < l; i++) {
      var track = this[i];

      if (track.id === id) {
        result = track;
        break;
      }
    }

    return result;
  };

  return TextTrackList;
})(_trackList2['default']);

exports['default'] = TextTrackList;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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